import React, { Component, PropTypes } from 'react';
import MaskedTextField from './c_MaskedTextField';

export default function PhoneNumberField(props) {

  const {
    className = 'phone-number',
    floatingLabelText = 'Phone Number',
    optional = false,
    ['data-id']: dataId,
    ...attributes
  } = props;
  const mask = '(999) 999-9999';

  return (
    <MaskedTextField
      hideMaskChar
      data-id={dataId}
      className={className}
      floatingLabelText={floatingLabelText}
      mask={mask}
      {
        ...attributes
      }
    />
  );
}



// WEBPACK FOOTER //
// ./shared/common/components/PhoneNumberField.js